<img [src]="image" class="img" alt="">
<div class="text">
  <ng-content></ng-content>
</div>